import gql from 'graphql-tag';

const SELLER_STATUS_FRAGMENT = gql`
  fragment SellerStatusFragment on SellerStatus {
    featured_seller {
      ...SellerFragment
    }
    top_seller {
      ...SellerFragment
    }
  }
`;

export default SELLER_STATUS_FRAGMENT;
